import React from 'react';
import classNames from 'classnames';
import i18next from 'i18next';
import { NavLink } from 'react-router-dom';
import ButtonBorder from '../../Button/ButtonBorder';
import Icon from '../../Icon/Icon';
import coinBigIcon from 'icons/coin-big.svg';
import expandIcon from 'icons/stake-expand.svg';
import lockCloseIcon from 'icons/lock-close.svg';
import playIcon from 'icons/play.svg';
import Market from '../Market/Market';
import { connect } from 'react-redux';
import { gameLogo } from '../../../utils/index';
import { setChannel } from '../../../actions/playerActions';

class ShortEvent extends React.PureComponent {
  render() {
    const { event, setChannel } = this.props;

    const {
      name_ht,
      name_at,
      logo_at,
      logo_ht,
      ch_name,
      time_name,
      date_start,
      event_id,
      cnt_bet,
      score,
      score_dop,
      game,
    } = event;

    const mainMarket = event.main_bet;
    const eventName = [name_ht, name_at].join(' vs ');

    return (
      <div className={classNames('short-event')}>
        <div className="short-event__inner">
          <div className="short-event__info">
            <div className="short-event__map">
              <img src={gameLogo(game)} />
              {mainMarket && <div>{mainMarket.title}</div>}
            </div>
            {event.live === 1 && (
              <div className="short-event__live">
                Live
                {event.broadcast_channel && (
                  <span
                    className="short-event__play button"
                    onClick={setChannel.bind(
                      null,
                      event.broadcast_channel,
                      eventName
                    )}
                  >
                    <Icon glyph={playIcon} />
                  </span>
                )}
              </div>
            )}
            <span className="short-event__time">
              {event.live ? time_name : date_start}
            </span>
            <span className="short-event__league">{ch_name}</span>
          </div>

          <Market marketId={mainMarket} renderAnyway={true}>
            {({ outcomes, market }) => {
              const withDraw = market && +market.column === 3;
              const homeBet = outcomes[0];
              const drawBet =
                withDraw && outcomes.length === 3 ? outcomes[1] : null;
              const awayBet = outcomes[withDraw ? 2 : 1];

              return (
                <React.Fragment>
                  <div
                    className={classNames(
                      'short-event__team-block',
                      'short-event__team-block--home'
                    )}
                  >
                    <div className="short-event__logo">
                      <img src={`/img/logo/${logo_ht}`} />
                    </div>
                    <div className="short-event__team-middle">
                      <span className="short-event__team-name">{name_ht}</span>
                      {homeBet && (
                        <span className="short-event__chance-percent">
                          {homeBet['chance'] + '%'}
                        </span>
                      )}
                    </div>

                    {homeBet && homeBet.cf && homeBet.status ? (
                      <ButtonBorder
                        onClick={homeBet.toggleBet}
                        className={classNames('short-event__cf', {
                          active: homeBet.selected,
                        })}
                      >
                        {homeBet.cf.toFixed(2)}
                      </ButtonBorder>
                    ) : (
                      <ButtonBorder
                        className={classNames('short-event__cf', {
                          disabled: true,
                        })}
                      >
                        <Icon glyph={lockCloseIcon} />
                      </ButtonBorder>
                    )}

                    <div className="short-event__chance-block">
                      <span className="short-event__chance-bar">
                        <span
                          style={{
                            height: homeBet ? `${homeBet['chance']}%` : '50%',
                          }}
                        />
                      </span>
                    </div>
                  </div>
                  <div
                    className={classNames('short-event__middle', {
                      'short-event__middle--draw': withDraw,
                    })}
                  >
                    {(!withDraw || !score) && (
                      <span className="short-event__vs">vs</span>
                    )}

                    {score && (
                      <span className="short-event__score">
                        <span>{score}</span> {score_dop ? `(${score_dop})` : ''}
                      </span>
                    )}

                    {withDraw && (
                      <React.Fragment>
                        {drawBet && drawBet.cf && drawBet.status ? (
                          <ButtonBorder
                            onClick={drawBet.toggleBet}
                            className={classNames(
                              'short-event__cf',
                              'short-event__cf--draw',
                              { active: drawBet.selected }
                            )}
                          >
                            {drawBet.cf.toFixed(2)}
                          </ButtonBorder>
                        ) : (
                          <ButtonBorder
                            className={classNames(
                              'short-event__cf',
                              'short-event__cf--draw',
                              { disabled: true }
                            )}
                          >
                            <Icon glyph={lockCloseIcon} />
                          </ButtonBorder>
                        )}
                      </React.Fragment>
                    )}

                    <span className="short-event__league">{ch_name}</span>
                  </div>
                  <div
                    className={classNames(
                      'short-event__team-block',
                      'short-event__team-block--away'
                    )}
                  >
                    <div className="short-event__chance-block">
                      <span className="short-event__chance-bar">
                        <span
                          style={{
                            height: awayBet ? `${awayBet['chance']}%` : '50%',
                          }}
                        />
                      </span>
                    </div>

                    {awayBet && awayBet.cf && awayBet.status ? (
                      <ButtonBorder
                        onClick={awayBet.toggleBet}
                        className={classNames('short-event__cf', {
                          active: awayBet.selected,
                        })}
                      >
                        {awayBet.cf.toFixed(2)}
                      </ButtonBorder>
                    ) : (
                      <ButtonBorder
                        className={classNames('short-event__cf', {
                          disabled: true,
                        })}
                      >
                        <Icon glyph={lockCloseIcon} />
                      </ButtonBorder>
                    )}

                    <div className="short-event__team-middle">
                      <span className="short-event__team-name">{name_at}</span>
                      {awayBet && (
                        <span className="short-event__chance-percent">
                          {awayBet['chance'] + '%'}
                        </span>
                      )}
                    </div>
                    <div className="short-event__logo">
                      <img src={`/img/logo/${logo_at}`} />
                    </div>
                  </div>
                </React.Fragment>
              );
            }}
          </Market>

          <NavLink
            exact
            to={`/esports/${event_id}`}
            className="short-event__stakes"
          >
            <div>
              <Icon glyph={coinBigIcon} />
              <div className="short-event__stakes-title">
                {i18next.t('short_event.bets')}
              </div>
              <div className="short-event__stakes-count">
                {cnt_bet ? (
                  <span>+{cnt_bet}</span>
                ) : (
                  <Icon glyph={lockCloseIcon} />
                )}
              </div>
              <Icon glyph={expandIcon} className="short-event__expand" />
            </div>
          </NavLink>
        </div>
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => {
    const getEvent = (eventId) =>
      state.events['prematch'][eventId] || state.events['live'][eventId];
    const event = getEvent(ownProps.eventId);

    return {
      event,
    };
  },
  {
    setChannel,
  }
)(ShortEvent);



// WEBPACK FOOTER //
// ./app/components/EsportsGame/ShortEvent/ShortEvent.jsx